import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { cn } from '../../../../ui/utils/cn';

interface ImageUploadSectionProps {
    previewUrl: string | null;
    isDragging: boolean;
    onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
    onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
    onClick: () => void;
    inputRef: React.RefObject<HTMLInputElement>;
    onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ImageUploadSection: React.FC<ImageUploadSectionProps> = ({
    previewUrl,
    isDragging,
    onDragOver,
    onDragLeave,
    onDrop,
    onClick,
    inputRef,
    onFileChange,
}) => {
    return (
        <div
            className={cn(
                "rounded-2xl cursor-pointer transition-all duration-200",
                isDragging && "bg-mint/10"
            )}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            onClick={onClick}
        >
            <input type="file" ref={inputRef} onChange={onFileChange} accept="image/*" className="hidden" />

            {previewUrl ? (
                <div className="space-y-3">
                    <div className="w-full max-h-[400px] overflow-hidden rounded-xl">
                        <img src={previewUrl} alt="Selected coffee" className="w-full h-full object-contain" />
                    </div>
                    <p className="text-xs text-muted-foreground text-center">Click or drag to change</p>
                </div>
            ) : (
                <div className={cn(
                    "w-full h-52 border-2 border-dashed rounded-2xl flex items-center justify-center transition-all",
                    isDragging ? "border-mint bg-mint/5" : "border-gray-300 hover:border-mint/50 hover:bg-mint/5"
                )}>
                    <div className="text-center space-y-2">
                        <FontAwesomeIcon icon={faImage} className="text-4xl text-gray-400" />
                        <p className="text-sm text-gray-500">Click or drag image here</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImageUploadSection;


